function buildUrl(endpoint) {
  return `${process.env.API_BASE_URL.replace(/\/$/, '')}/${endpoint.replace(/^\//, '')}`
}

const defaultFetchOptions = {
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'same-origin',
  redirect: 'follow',
  referrerPolicy: 'no-referrer'
}

export const postData = async (endpoint, data, signal) => {
  try {
    const response = await fetch(buildUrl(endpoint), {
      ...defaultFetchOptions,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      signal
    })

    if (!response.ok) {
      let errorMessage = 'Network response was not ok'

      try {
        const errorData = await response.json()
        if (errorData.message) {
          errorMessage = errorData.message
        } else if (errorData.error) {
          errorMessage = errorData.error
        } else if (errorData.data?.error) {
          errorMessage = errorData.data.error
        }
        throw new Error(errorMessage)
      } catch (parseError) {
        throw new Error(parseError || 'Failed to parse error response from server')
      }
    }

    return await response.json()
  } catch (error) {
    throw new Error(`Error in ${endpoint}: ${error}`)
  }
}

export const getData = async (endpoint, options = {}) => {
  try {
    const response = await fetch(buildUrl(endpoint), {
      ...defaultFetchOptions,
      method: 'GET',
      ...options
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    try {
      return await response.json()
    } catch {
      return await response.text()
    }
  } catch (err) {
    console.error('GET request failed:', endpoint, err)
    throw err
  }
}

export const sendNotification = async ({ message = 'Error', mention = true }) => {
  const url = new URL(window.location.href)
  const screenUuid = url.searchParams.get('screenUuid')

  try {
    const response = await fetch(
      'https://discord.com/api/webhooks/1353943680553324646/ZDb_TtJqwCnR50JRzcTJTHklJ4b89n4-ccI8sMIDuh2C_QiO9X2-TF3CtOGqol0Oxg__',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          content: `[${process.env.MODE}][${screenUuid}] - ${message}${
            mention ? '\ncc: <@&1181093434547769344>' : ''
          }`
        })
      }
    )

    if (response.status === 204) {
      console.info('Notification sent successfully to Discord')
    } else {
      throw new Error(`Discord notification failed: ${response.statusText}`)
    }
  } catch (error) {
    console.error('Error sending notification to Discord:', error)
  }
}

export const sendToLoggingService = async (logData) => {
  try {
    const response = await fetch('https://logging.stickearn.net/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(logData)
    })
    return response.ok
  } catch (error) {
    console.error('❌ Logging service error:', error)
    await sendNotification({
      message: `Logging service error: 'https://logging.stickearn.net' ${error.toString()}`,
      mention: true
    })
    return false
  }
}
